// Add CSS for reaction animation
if (typeof document !== 'undefined') {
  const existingStyle = document.head.querySelector('style[data-reaction-float]')
  if (!existingStyle) {
    const style = document.createElement('style')
    style.setAttribute('data-reaction-float', 'true')
    style.textContent = `
      @keyframes reactionFloatUp {
        0% {
          transform: translateY(0) scale(0.3);
          opacity: 0;
        }
        5% {
          transform: translateY(-20px) scale(0.6);
          opacity: 0.8;
        }
        15% {
          transform: translateY(-60px) scale(1);
          opacity: 1;
        }
        85% {
          transform: translateY(-300px) scale(1.05);
          opacity: 1;
        }
        100% {
          transform: translateY(-350px) scale(0.8);
          opacity: 0;
        }
      }
      
      @keyframes floatingWaves {
        0% {
          transform: translateY(0) translateX(0) scale(0.4);
          opacity: 0;
        }
        5% {
          transform: translateY(-20px) translateX(8px) scale(0.55);
          opacity: 0.7;
        }
        10% {
          transform: translateY(-40px) translateX(18px) scale(0.75);
          opacity: 0.95;
        }
        15% {
          transform: translateY(-60px) translateX(22px) scale(0.88);
          opacity: 1;
        }
        20% {
          transform: translateY(-80px) translateX(15px) scale(0.95);
          opacity: 1;
        }
        25% {
          transform: translateY(-100px) translateX(0) scale(1);
          opacity: 1;
        }
        30% {
          transform: translateY(-120px) translateX(-15px) scale(1.02);
          opacity: 1;
        }
        35% {
          transform: translateY(-140px) translateX(-22px) scale(1.03);
          opacity: 1;
        }
        40% {
          transform: translateY(-160px) translateX(-18px) scale(1.04);
          opacity: 1;
        }
        45% {
          transform: translateY(-180px) translateX(-8px) scale(1.05);
          opacity: 1;
        }
        50% {
          transform: translateY(-200px) translateX(0) scale(1.05);
          opacity: 1;
        }
        55% {
          transform: translateY(-220px) translateX(10px) scale(1.04);
          opacity: 1;
        }
        60% {
          transform: translateY(-240px) translateX(20px) scale(1.02);
          opacity: 1;
        }
        65% {
          transform: translateY(-260px) translateX(22px) scale(1);
          opacity: 1;
        }
        70% {
          transform: translateY(-280px) translateX(15px) scale(0.98);
          opacity: 1;
        }
        75% {
          transform: translateY(-300px) translateX(0) scale(0.95);
          opacity: 1;
        }
        80% {
          transform: translateY(-320px) translateX(-12px) scale(0.88);
          opacity: 0.95;
        }
        85% {
          transform: translateY(-340px) translateX(-18px) scale(0.78);
          opacity: 0.85;
        }
        90% {
          transform: translateY(-360px) translateX(-12px) scale(0.65);
          opacity: 0.7;
        }
        95% {
          transform: translateY(-390px) translateX(-5px) scale(0.52);
          opacity: 0.5;
        }
        100% {
          transform: translateY(-420px) translateX(0) scale(0.4);
          opacity: 0;
        }
      }
    `
    document.head.appendChild(style)
  }
}
